import Image from 'next/image'
import { Drawer, IconButton } from 'rsuite'
import DirectionalArrow from '@/components/themes/common/icons/directionalArrow'
import useTranslation from '@/hooks/useTranslation'
import styles from './mobileMenuDrawer.module.scss'
import ChangeVehicleIcon from '@/components/themes/common/icons/changeVehicleIcon'

function NordicsMobileMenuDrawer({ open, onClose, title, image, model, year, onChangeVehicle }) {
  const t = useTranslation()
  const drawerTitle = year && model ? `${year} ${model}` : title

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="left"
      size="full"
      closeButton={false}
      className={styles.mobileMenuDrawer}
    >
      <Drawer.Body className={styles.drawerBody}>
        <div className={styles.drawerTopBar}>
          <IconButton
            id="btn-close-mobile-menu"
            className={styles.backButton}
            icon={<DirectionalArrow direction="left" />}
            appearance="ghost"
            onClick={onClose}
          >
            {t('back_to_contents', 'Back to Contents')}
          </IconButton>
        </div>
        <div className={styles.mobileMenuContent}>
          <IconButton
            id="btn-changeVehicle-mobile"
            className={styles.vehicleBtn}
            icon={<ChangeVehicleIcon />}
            size="md"
            appearance="ghost"
            onClick={onChangeVehicle}
          >
            {t('header_change_vehicle', 'Change Vehicle')}
          </IconButton>
          <div className={styles.mobileMenuTitle}>{drawerTitle}</div>
          {image && (
            <div className={styles.mobileMenuImageWrapper}>
              <Image src={image} alt="Model" height={320} width={560} className={styles.mobileMenuImage} />
            </div>
          )}
        </div>
      </Drawer.Body>
    </Drawer>
  )
}

export default NordicsMobileMenuDrawer
